import { render, staticRenderFns } from "./SignUpCancel.vue?vue&type=template&id=0e4e8981&"
import script from "./SignUpCancel.vue?vue&type=script&lang=js&"
export * from "./SignUpCancel.vue?vue&type=script&lang=js&"
import style0 from "./SignUpCancel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports